export const coreWalletTypes = [
	'Wallet',
	'Sms',
	'User',
	'Address',
	'BindingItem',
	'Transfer',
	'BlackWhiteList',
	'BlackWhiteListItem',
	'ShopConfiguration',
	'PurchaseFailure',
	'PurchaseRefund',
	'Purchase',
	'AccountItem',
	'Account',
	'TokenInfo',
	'ExchangeRate',
	'LoyaltyCredit',
	'BinGroup',
	'LoyaltyProgram',
	'LoyaltyProgramMembership',
	'Payment.PaymentInstrument',
	'UserIdDocument',
	'Payment.BusinessContract',
	'BusinessContractRoute',
	'Voucher',
	'Payment.PaymentResult',
	'UserEmail',
	'PermittedAction',
	'ActionPermissionConfiguration',
	'Payment.PaymentSession',
	'Subsidiary',
	'SepaTransaction',
	'SepaFile',
	'UserPhoneNumber',
	'TransactionStatisticConfiguration',
	'SepaTransaction',
	'FeeInstance',
	'FeeDefinition',
	'PaymentCallback',
	'Invoice',
	'P2PTransaction',
	'PaymentApproval',
	'PaymentTransaction',
	'FeeGroup',
	'InvoiceItem',
	'BalanceTransaction',
	'Payment',
	'VatDefinition',
	'WalletFile',
	'PaymentInstrument',
	'PaymentAction',
	'WalletNotification',
	'WalletAccount',
	'PaymentFailure',
	'UnmatchedPayment',
	'WalletPaymentInstrumentDocument',
	'WPIVProcess',
	'EntityPropertyChangeWitness',
	'PasswordForgottenProcessData',
	'Payment.PaymentTransactionLog',
	'SettlementPayment',
	'BillingPeriodRevenueEntry',
	'BillingGroupMembership',
	'Settlement',
	'BillingPeriod',
	'BillingGroup',
	'BillingSchedule',
	'UserVerificationHistoryEntry',
	'LimitGroup',
	'BillingEvent',
	'LimitDefinition',
	'SettlementConfiguration',
	'BillingPeriodSummary',
	'WalletAccountItem',
	'BillingPeriodSummaryEntry',
	'DepositItem',
	'Deposit'
];

export const coreWalletTypeToResourceMapping = {
	AccountItem: 'accountingAccountItems',
	Account: 'accountingAccounts',
	Transfer: 'accountingAccountTransfers',
	BinGroup: 'binGroups',
	BlackWhiteListItem: 'blackWhiteListItems',
	BlackWhiteList: 'blackWhiteLists',
	BusinessContractRoute: 'businessContractRoutes',
	'Payment.BusinessContract': 'businessContracts',
	FeeDefinition: 'feeDefinitions',
	Invoice: 'invoices',
	LimitDefinition: 'limitDefinitions',
	PaymentApproval: 'paymentApprovals',
	PaymentFailure: 'paymentFailures',
	PaymentInstrument: 'paymentInstruments',
	PaymentTransaction: 'paymentTransactions',
	Payment: 'payments',
	'Payment.PaymentResult': 'paymentTransactions',
	Subsidiary: 'subsidiaries',
	UnmatchedPayment: 'unmatchedPayments',
	User: 'users',
	VatDefinition: 'vatDefinitions',
	WalletAccountItem: 'walletAccountItems',
	WalletAccount: 'walletAccounts',
	WalletNotification: 'walletNotifications',
	Wallet: 'wallets',
	BalanceTransaction: 'balanceTransactions',
	ShopConfiguration: 'shopConfigurations',
};
